import React from 'react';
import { Loading } from 'components/Loading';

import MainContent from 'components/MainContent';

import { Flexer } from '@ontruck/orc';

const LoadingSection = () => (
  <MainContent>
    <Flexer.Parent alignItems="center" justifyContent="center" pBottom="L">
      <Flexer.Child pBottom="L">
        <Loading />
      </Flexer.Child>
    </Flexer.Parent>
  </MainContent>
);

export default LoadingSection;
